var _ = require('underscore');

module.exports = function escapeHTML (str) {
  return _.escape(str);
};



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/util/escape-html.js
// module id = 57
// module chunks = 0 2